export const buildArtistSuggestionsFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: (filterOptions.venue_ownerships || []).map(o => ({
          value: String(o.id),
          label: o.name,
        })),
      },
    ],
  },
  {
    id: 'artist',
    label: 'Artist',
    filters: [
      {
        id: 'on_tour_only',
        label: 'Touring',
        type: 'checkbox',
        options: [{ value: 'true', label: 'Currently touring' }],
      },
      {
        id: 'never_played_here_only',
        label: 'History',
        type: 'checkbox',
        options: [{ value: 'true', label: 'Never played here' }],
      },
    ],
  },
];
